// Translations
import landing from '../views/landing/translations/ar'

// Translation: Register (Arabic)
export default Object.freeze({
	name: 'إنشاء حساب',
	views: { landing }
})
